import { useEffect, useLayoutEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { progress } from './loadingProgress';
import type { ProgressState } from './loadingProgress';

/**
 * TopProgressBar: the thin bar across the top of the window that shows a
 * page is loading, as on GitHub. It is decorative — screen readers get the
 * pages' own loading states — so it is hidden from them.
 */
export function TopProgressBar() {
  const location = useLocation();
  const [state, setState] = useState<ProgressState>({ value: 0, visible: false });

  useEffect(() => progress.subscribe(setState), []);

  // A layout effect, so a page change starts the run before the new page's
  // own effects send their first requests and the bar sees them.
  useLayoutEffect(() => {
    progress.start();
  }, [location.pathname, location.search]);

  return (
    <div className={`top-progress${state.visible ? ' top-progress--visible' : ''}`} aria-hidden="true" data-testid="top-progress">
      <div className="top-progress__bar" style={{ transform: `scaleX(${state.value / 100})` }} />
    </div>
  );
}
